import React from 'react';
import { Thumbnail, Grid, Row, Col } from 'react-bootstrap';
import { getWorkflowImage } from '../../../../api/ispyb.js';
import PropTypes from 'prop-types';

export default class WorkflowDataCollectionGroupPanel extends React.Component {

    getWorkflowsData(){
        /** To arrays */
        var workflows = [];
        try{
            
            var ids = this.props.datacollectiongroup.workflowStepIds.split(",");
            var type = this.props.datacollectiongroup.workflowStepTypes.split(",");
            var status = this.props.datacollectiongroup.workflowStepStatuses.split(",");
            for (var i = 0; i < ids.length; i++){
                workflows.push({
                    id : ids[i],
                    type : type[i],
                    status : status[i]
                })
            }
        }
        catch(e){
            console.log(e);
            console.log("Error parsing workflow data");
        }
        return workflows;
    }

    render() { 
        if (this.props.datacollectiongroup.workflowId){
                var url = "/sessions/mx/proposal/:proposal/session/:sessionId/workflow/:workflowId/steps/:workflowStepIds" 
                .replace(':token', this.props.token)
                .replace(':proposal', this.props.proposal)
                .replace(':sessionId', this.props.sessionId)
                .replace(':workflowId', this.props.datacollectiongroup.workflowId)        
                .replace(':workflowStepIds', this.props.datacollectiongroup.workflowStepIds);
                
                let workflows = this.getWorkflowsData();

                return  <Grid fluid><Row>{workflows.map((value, index) =>{                                                          
                        return <Col sm={12} md={2} lg={1}>
                                    <Thumbnail style={{width:'150px'}}src={getWorkflowImage(this.props.user, this.props.proposal, value.id)} alt="242x200">
                                            <h4><a href={url} target="_blank">{value.type}</a></h4>
                                            <p>{value.status}</p>
                                            <p>                          
                                        </p>
                                    </Thumbnail>
                        </Col>                                                                                                                      
                })}</Row></Grid>;  
        }
        return null;

    }
}

WorkflowDataCollectionGroupPanel.propTypes = {
  user: PropTypes.object,
  proposal: PropTypes.string,
  sessionId: PropTypes.string,
  workflowId: PropTypes.string,
  workflowStepIds: PropTypes.string,
  workflowStepTypes: PropTypes.string,
  workflowStepStatuses: PropTypes.string                
};




// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/WorkflowDataCollectionGroup/WorkflowDataCollectionGroupPanel.js